import { Component, Input, Renderer2, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentSectionModel } from 'src/app/shared/common-components/payment-section/payment-section.model';
import { PaymentMethod, StorageName } from 'src/app/shared/enum/common-enum';
import { VoucherType, VoucherTypeName } from 'src/app/shared/models/common.model';
import { CommonService } from 'src/app/shared/services/common.service';
import { InvestmentFundService } from '../../investment-fund.services';
import { catchError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ResponseModel } from 'src/app/shared/models/response-model.model';
import { PaymentSectionComponent } from 'src/app/shared/common-components/payment-section/payment-section.component';
import { StorageService } from 'src/app/shared/services/storage.service';
import { IconHover } from '../../../../../shared/enum/common-enum';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-fund-transfer-withdraw-popup',
  templateUrl: './fund-transfer-withdraw-popup.component.html',
  styleUrls: ['./fund-transfer-withdraw-popup.component.scss']
})
export class FundTransferWithdrawPopupComponent extends CommonService{
  @ViewChild("FundTransferForm") FundTransferForm!: NgForm;
  formName = StorageName.FORMNAME_TRANSACTION_INVESTMENT_LAYAWAYS_FUND;
  invoiceDate : any;
  currentHoverEffect = IconHover.Pink;
  paymentSectionModel     = new PaymentSectionModel();
  getAllDropdownModel  : any = {};
  @ViewChild(PaymentSectionComponent) paymentSectionComponent: PaymentSectionComponent;
  @Input() data: any={};

  constructor(
    public activeModal: NgbActiveModal,
    public storageservice: StorageService,
    public toaster: ToastrService,
    public renderer: Renderer2,
    public investmentFundService: InvestmentFundService,
    public notificationService: NotificationService,
    ) {
    super(renderer);
  }

  ngOnInit() {
    this.initialCalls()
    this.setVisibilityInstance();
    this.data.formModel.invoiceModel.extraPaidPer =0
    this.data.formModel.invoiceModel.extraPaidAmount =0
    this.calculateTotalAmount();

    
  }
  setVisibilityInstance(){
    this.paymentSectionModel.setVisibility(StorageName.INVESTMENT_FUND_INSTALLMENT_ENTRY_WITHDRAW_GRID,false);
}
initialCalls()
{
  this.data.formModel.voucherType = VoucherTypeName.FundWithdraw;
  this.data.formModel.invoiceModel.voucherTypeId = VoucherType.FundWithdraw;
  this.data.fundTransferId;
  this.data.fundWithdrawId;
  this.getFundDataById()
}
getFundDataById()
{
  this.data?.modalTitle

  const fundId = this.data?.modalTitle == 'Fund Withdraw' ? this.data?.fundWithdrawId : this.data?.fundTransferId;
  const getDataObservable =  this.data.modalTitle == 'Fund Withdraw' ? this.investmentFundService.Getfundwithdrawbyid(fundId) : this.investmentFundService.Getfundtransferbyid(fundId);
  getDataObservable.pipe(catchError((err) => this.handleError(err))).subscribe((res: ResponseModel) => {
    if (res.isSuccess) {
     let data = res?.response;
     this.data.formModel = data;
     this.data.formModel.invoiceModel.extraPaidAmount = this.data?.formModel?.invoiceModel?.extraPaidAmount?.toFixed(2)
     this.paymentSectionComponent?.gridApi?.api?.setRowData( this.data?.formModel?.paymentList);
    }else{
      this.data.formModel.invoiceModel.extraPaidAmount = this.data?.formModel?.invoiceModel?.extraPaidAmount?.toFixed(2)
    }
  });
}


selectedRangeDates(event?: any) {
  this.invoiceDate = event;
}

addInvoice()  {
  if (this.FundTransferForm?.valid) {
    this.data.formModel.invoiceModel.date = this.invoiceDate;
    this.data.formModel.invoiceModel.fundTransferOrWithdraw =this.data?.FundTransferOrWithdraw;
      this.investmentFundService.insertfundtransferandwithdraw(this.data?.formModel).pipe(catchError((err) => this.handleError(err))).subscribe((res: ResponseModel) => {
        if (res?.isSuccess) {
          this.toaster.success(res?.message);
          this.activeModal.close(res);
        } else
        {
          this.data.formModel.invoiceModel.id = res?.response;
          this.notificationService.errorPopup(res?.errors[0]);
        } 
      });
    }
}
onExtraPaidAmountChange(value: number) {
  this.data.formModel.invoiceModel.extraPaidAmount = value;
  const { extraPaidPer = 0, amount = 0 } = this.data?.formModel?.invoiceModel;
  const totalAmount = Number(amount) + Number(this.data?.formModel?.invoiceModel?.extraPaidAmount) ;
  this.data.formModel.invoiceModel.totalAmount = totalAmount;
}

onExtraPaidChange(value: number) {
  this.data.formModel.invoiceModel.extraPaidPer = value;
  this.calculateTotalAmount();
}
onAmountChange(value: number) {
  this.data.formModel.invoiceModel.amount = value;
  this.calculateTotalAmount();
}

calculateTotalAmount(): void {
  const { extraPaidPer = 0, amount = 0 } = this.data?.formModel?.invoiceModel;
  const extraPaidAmount = (Number(extraPaidPer) / 100) * Number(amount);
  const totalAmount = Number(amount) + extraPaidAmount;
  this.data.formModel.invoiceModel.extraPaidAmount = extraPaidAmount.toFixed(2);
 // this.data.formModel.invoiceModel.totalAmount = this.data.FundTransferOrWithdraw === FundTransferOrWithdraw.FundTransfer? extraPaidAmount.toFixed(2): totalAmount.toFixed(2);
 this.data.formModel.invoiceModel.totalAmount = totalAmount;
}



addDataPaymentGrid(){
const data = [
  {
    paymentMethodId: PaymentMethod?.Cash, 
    amount: this.data.formModel?.invoiceModel?.totalAmount
  },
];

  this.paymentSectionComponent.AddDatainPaymentList(data)
}


fillDropdownData() {
  this.paymentSectionComponent?.fillDropdownData();
}

ngOnDestroy(): void {
}

}

export enum FundTransferOrWithdraw{
  FundTransfer = 1,
  FundWithdraw = 2,
}